import styles from './styles.module.scss';

const NdviScale = () => {
  return (
    <div className={styles.ndviScale}>
      <div className={styles.ndviScaleValues}>
        <span>0</span>
        <span>0.5</span>
        <span>1</span>
      </div>
      <div className={styles.ndviScaleLine}></div>
    </div>
  )
};

export default NdviScale;
